import React from 'react';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { BlockFieldColumn } from 'web-ui-components/lib/global/layout';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from 'prop-types';
import TextQuestionComponent from './TextQuestionComponent';
import { Country } from '../../../components/Country';
import {
  ADDRESS_LINE,
  COUNTRY_NAME_INT,
  CITY_NAME,
  COUNTRY_TYPE_ADDRESS
} from '../addressUtils/addressConstants';
import { isRequired } from '../../../utils/validation';

const InternationalAddressComponent = ({ type, values }) => (
  <Content>
    {({ CountryName, CountryNameError }) => (
      <div>
        <TextQuestionComponent
          type={`${type}.international`}
          name={`${ADDRESS_LINE}1`}
          label={'AddressLine1'}
          labelError="AddressLine1Error"
          optionalField={false}
        />
        <TextQuestionComponent
          type={`${type}.international`}
          name={`${ADDRESS_LINE}2`}
          label={'AddressLine2'}
          labelError="AddressLine2Error"
          optionalField={true}
        />
        <TextQuestionComponent
          type={`${type}.international`}
          name={`${ADDRESS_LINE}3`}
          label={'AddressLine3'}
          labelError="AddressLine3Error"
          optionalField={true}
        />
        <TextQuestionComponent
          type={`${type}.international`}
          name={`${ADDRESS_LINE}4`}
          label={CITY_NAME}
          labelError="CityNameIntError"
          columnWidth={3}
          optionalField={true}
        />
        <Field
          name={`${type}.international.${COUNTRY_NAME_INT}`}
          subscription={{ touched: true, error: true }}
        >
          {({ meta: { touched, error } }) => (
            <FormField>
              <FieldHeader
                name={`${type}.international.${COUNTRY_NAME_INT}`}
                hasError={touched && !!error}
                title={CountryName}
                validationMessage={CountryNameError}
              />
              <FieldBody hasError={touched && !!error}>
                <Field
                  name={`${type}.international.${COUNTRY_NAME_INT}`}
                  component="select"
                  validate={isRequired}
                >
                  {({ input }) => (
                    <BlockFieldColumn column={6}>
                      <Country
                        name={`${`${type}.international`}${COUNTRY_NAME_INT}`}
                        removeCountries={['United Kingdom']}
                        type={COUNTRY_TYPE_ADDRESS}
                        values={values}
                        addressType={type}
                        {...input}
                      />
                    </BlockFieldColumn>
                  )}
                </Field>
              </FieldBody>
            </FormField>
          )}
        </Field>
      </div>
    )}
  </Content>
);

InternationalAddressComponent.propTypes = {
  type: PropTypes.string.isRequired
};

export default InternationalAddressComponent;
